import { CALENDAR_GROUPS } from '@/views/constants'
import { ScreeningSettings } from '@/utils/screeningSettings'

export default {
  timeBlocks: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.timeBlocks ?? null
  },
  fieldSettings: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.settings?.fields ?? null
  },
  reasons: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.additionalData?.reasons ?? []
  },
  calendarInsurances: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.additionalData?.insurances ?? []
  },
  calendarFooterText: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.displayInfo?.footerText ?? null
  },
  screeningSettings: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.settings.screening ?? null
  },
  calendarTitle: (state) => {
    let calendarWithLowestId = null
    for (const calendarKey in state.calendars) {
      if (!calendarWithLowestId || calendarWithLowestId.id > state.calendars[calendarKey].id) {
        calendarWithLowestId = state.calendars[calendarKey]
      }
    }
    const defaultTitle = 'Book an appointment'
    return calendarWithLowestId ? calendarWithLowestId?.displayInfo?.label ?? defaultTitle : defaultTitle
  },
  getRequestQueue: (state) => {
    return state.requestQueue
  },
  getQueueItem: (state) => (calendarIndex) => {
    return state.requestQueue.find(el => {
      return el.calendarIndex === calendarIndex
    })
  },
  getResponseCanBeProcessed: ({ requestQueue }, getters) => (calendarIndex) => {
    const queueItem = getters.getQueueItem(calendarIndex)
    return queueItem.id === 0 || requestQueue[queueItem.prevItemIndex].processed
  },
  getFormatedApptPhoneForCalendar: (state) => (calendarIndex) => {
    return state.calendars?.[calendarIndex]?.displayInfo?.phoneFormatted ?? ''
  },
  someCalendarsWithScreeningQuestions: (state) => {
    return Object.values(state.calendars).some((calendar) => {
      return Boolean(calendar?.settings?.screening) && Boolean(calendar?.settings?.screening !== '' && calendar?.settings?.screening.length > 0)
    })
  },
  appointmentTypeComplexityExist: (state) => {
    return state.reasons && Object.values(state.reasons).some((reason) => {
      return (Boolean(reason.locationId) || Boolean(reason.doctorId)) && (state.appointmentTypesEnabled ? !!reason.appointmentTypeUuid : true)
    })
  },
  getPracticeGroup (state, getters) {
    if (!getters.someCalendarsWithScreeningQuestions && !getters.appointmentTypeComplexityExist) {
      return CALENDAR_GROUPS.A
    } else if (getters.someCalendarsWithScreeningQuestions && !getters.appointmentTypeComplexityExist) {
      return CALENDAR_GROUPS.B
    } else if (getters.appointmentTypeComplexityExist) {
      return CALENDAR_GROUPS.C
    }
  },
  thisCalendarIdAlreadySaved (state) {
    return (id) => {
      return state.savedCalendarsIds.has(id)
    }
  },
  allAppointmentTypes (state) {
    return state.appointmentTypes
  },
  allAppointmentTypesWithActiveConfigurations (state) {
    return state.appointmentTypes.filter(apptType => apptType.configurations.some(config => config.active))
  },
  allAppointmentTypesByScheduleIds (state) {
    return (scheduleIds = []) => {
      return state.appointmentTypes.filter(apptType => apptType.configurations.some(config => scheduleIds.includes(config.scheduleId)))
    }
  },
  configuredAppointmentTypesByScheduleIdsList (state, getters) {
    return (scheduleIds = []) => {
      return getters.allAppointmentTypesByScheduleIds(scheduleIds).filter(apptType => apptType.configurations.some(config => config.active && scheduleIds.includes(config.scheduleId)))
    }
  },
  googleMapsApiKey: state => state.googleMapsApiKey,
  telehealthPractice (state, getters) {
    return Object.entries(state.calendars).every(([calendarId]) => {
      return ScreeningSettings.hasTelehealthEnabled(getters.screeningSettings(calendarId))
    })
  }
}
